import React, { useCallback } from 'react';

import { TextField } from '@gogame/components';
import { withFormField, omitFormProps } from '@gogame/form';

import * as CREATIVES from 'scenes/Gallery/GalleryPage/Creatives/constants';

const RootJiraTaskFormField = withFormField()(({
  area,
  form,
  name,
  ...props
}) => {
  const handleChange = useCallback(
    (_e, value) => {
      form.setValues({
        ...form.values,
        [name]: value,
        [CREATIVES.CREATIVES]: form.values[CREATIVES.CREATIVES].map(
          (creative) => ({
            ...creative,
            [CREATIVES.JIRA_TASK]: value,
          })
        ),
      });
    },
    [form.setValues, form.values]
  );

  return (
    <TextField
      loading={area.loading}
      {...omitFormProps(props)}
      onChange={handleChange}
      data-cy={props.name}
    />
  );
});

export default RootJiraTaskFormField;
